/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import sessionStore from 'store/sessionStore';
import aes from './aes';
import { IAuthData } from './models';

const AUTH_STORE_KEY = 'authData';
const LOGIN_ID = 'loginId';
export const SESSION_START = 'sessionStart';
export const ROLE = 'role';
export const ROLENAME = 'userRoles';
export const MENU_DATA = 'menuData';
interface IPermissionMenuData {
  dashboard: boolean;
  transfers: boolean;
  prepaidCardLoad: boolean;
  billPayments: boolean;
  pendingRequests: boolean;
  mobileMoney: boolean;
  fxTransferRate: boolean;
  bankStatements: boolean;
  scheduleTransfers: boolean;
  transactionReports: boolean;
  beneficiaries: boolean;
  myRequests: boolean;
}

const initialPermissionaData: IPermissionMenuData = {
  dashboard: false,
  transfers: false,
  prepaidCardLoad: false,
  billPayments: false,
  mobileMoney: false,
  pendingRequests: false,
  fxTransferRate: false,
  bankStatements: false,
  scheduleTransfers: false,
  transactionReports: false,
  beneficiaries: false,
  myRequests: false,
};

export const permissionMapping = {
  Dashboard: 'dashboard',
  Transfers: 'transfers',
  'Prepaid Card Load': 'prepaidCardLoad',
  'Bill Payments': 'billPayments',
  'Mobile Money': 'mobileMoney',
  'FX Transfers and Rates': 'fxTransferRate',
  'Pending Request': 'pendingRequests',
  'Bank Statements': 'bankStatements',
  'Schedule Transfers': 'scheduleTransfers',
  'Transaction Reports': 'transactionReports',
  Beneficiaries: 'beneficiaries',
  'My Requests': 'myRequests',
};
const updatePermissions = (permissionArray: string[] | null, permissionData: IPermissionMenuData) => {
  if (!permissionArray) {
    return permissionData;
  }
  const updatedPermissionData = { ...permissionData };

  permissionArray.forEach((permission) => {
    const key = permissionMapping[permission] as keyof IPermissionMenuData;

    if (key && key in updatedPermissionData) {
      updatedPermissionData[key] = true;
    }
  });

  return updatedPermissionData;
};

class Auth {
  private authData: IAuthData | null = null;

  private permissionsData: IPermissionMenuData = initialPermissionaData;

  constructor() {
    this.refresh();
  }

  // getter && setter for AuthData
  get data(): IAuthData | null {
    return this.authData;
  }

  set data(data: IAuthData | null) {
    this.authData = data;
    const storageData = aes.encrypt(JSON.stringify(data));
    localStorage.setItem(AUTH_STORE_KEY, storageData);
    localStorage.setItem(LOGIN_ID, data?.loginId || '');
  }

  // Getter&Setter for permissions
  get permissions(): IPermissionMenuData {
    return this.permissionsData;
  }

  set permissions(data: IPermissionMenuData) {
    this.permissionsData = data;
  }

  login(data: IAuthData) {
    this.authData = data;
    const menuArray = data.menus.map((item) => item.title);
    const roleArray = data.roles.map((item) => item.name);
    const roles = data?.roles;
    const roleNames = roles ? roles.map((item) => item.name) : [];
    this.permissionsData = updatePermissions(menuArray, this.permissionsData);
    const storageData = aes.encrypt(JSON.stringify(this.authData));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    // this.formattedPermission = menuArray.map((field) => permissionMapping[field]);
    localStorage.setItem(AUTH_STORE_KEY, storageData);
    localStorage.setItem(LOGIN_ID, data.loginId);
    localStorage.setItem(ROLENAME, JSON.stringify(roleNames));
    localStorage.setItem(ROLE, JSON.stringify(roleArray));
    localStorage.setItem(SESSION_START, JSON.stringify(Date.now()));
    localStorage.setItem(MENU_DATA, JSON.stringify(menuArray));
    sessionStore.setSessionTimeout(false);
  }

  logout() {
    this.authData = null;
    this.permissionsData = initialPermissionaData;
    localStorage.removeItem(AUTH_STORE_KEY);
    localStorage.removeItem(LOGIN_ID);
    localStorage.removeItem(SESSION_START);
    localStorage.removeItem(ROLE);
    localStorage.removeItem(MENU_DATA);
    localStorage.removeItem(ROLENAME);
  }

  refresh() {
    const encData = localStorage.getItem(AUTH_STORE_KEY);
    if (encData) {
      this.authData = JSON.parse(aes.decrypt(encData)) as IAuthData;
    } else {
      this.authData = null;
    }
    const permissionStoredData = localStorage.getItem(MENU_DATA);
    // const storedData = permissionStoredData ? (JSON.parse(permissionStoredData) as string[]) : [];
    // this.formattedPermission = storedData.map(
    //   (field) =>
    //     // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    //     permissionMapping[field] || '',
    // );
    this.permissionsData = updatePermissions(
      JSON.parse(permissionStoredData as string) as string[],
      this.permissionsData,
    );
  }

  private formattedPermission: string[] = [];

  get modifiedPermission() {
    return this.formattedPermission;
  }

  set modifiedPermission(values) {
    const permissionStoredData = localStorage.getItem(MENU_DATA) || '';
    this.formattedPermission = JSON.parse(permissionStoredData) as string[];
  }
}

export default new Auth();
